import { featureImageSize } from "../const";
import {cardTitle, container, primaryColor, secondaryColor, title} from "../../nextjs-material-kit.js";
import imagesStyles from "../imagesStyles";

/**
 * Currently used for article detail page, article list component used on `/news` and `/advice`, and some old demos.
 */
const pageStyle = (theme) => ({
  section: {
    padding: "70px 0",
  },
  container: {
    ...container(theme),
  },
  detailSection: {
    margin: "auto",
    "@media (max-width: 768px)": {
      maxWidth: "100%",
    },
  },
  main: {
    position: "relative",
    zIndex: "3",
  },
  darkBlue: {
    // backgroundColor: "#095a70 !important",
    backgroundColor: primaryColor,
  },
  white_bg: {
    background: "#ffffff",
  },
});

export default pageStyle;
